import { format as dateFnsFormat } from 'date-fns';
import { getDateFnsLocale } from './get-date-fns-locale';

// The lab availability API keys months by their lowercase English abbreviation and echoes that
// same key back as the `month` field of every result, so the key is the wire format and must
// never be localized. Localize it only at the point of display, via these helpers.
const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

const getMonthIndexFromKey = (monthKey: string): number => MONTH_KEYS.indexOf(monthKey.toLowerCase());

// 'jan' or 'Jan' -> 'jan.' in Swedish, 'Jan' in English, 'tammi' in Finnish. Unrecognized input
// is returned unchanged rather than rendering a wrong month. DD-3807.
export const formatMonthKey = (monthKey: string): string => {
    const monthIndex = getMonthIndexFromKey(monthKey);
    if (monthIndex < 0) return monthKey;
    // Any non-leap year works here; only the month of this date is ever read.
    return dateFnsFormat(new Date(2001, monthIndex, 1), 'LLL', { locale: getDateFnsLocale() });
};
